import React from 'react';
import PropTypes from 'prop-types';

/**
 * The way out of the gifts shop, for a customer who got here mid-order.
 *
 * Gifts are an upsell on the road to checkout, so there has to be a visible way
 * past them. Every entry point that routes here from the order flow sets
 * `optional` (afterBuildRoute, OptionSelection, SeniorPackageChooser,
 * MultiPosePackageBuilder); a customer who followed a direct gifts link has no
 * order in progress and must NOT see this — there is nothing to continue to.
 *
 * FIXED to the viewport, not a button at the foot of the page. It was the
 * latter, which put it below twelve products: present on arrival, gone the
 * moment you scrolled, and absent from the product screen you are most likely
 * to be standing on when you decide you are done.
 *
 * Outlined rather than solid on purpose. On the product screen the solid blue
 * button is "add this to my order"; two solid blues competing would make
 * leaving look like the intended move on a page whose job is selling.
 */
export default function ContinueToCartBar({ onContinue }) {
  return (
    <div
      className={'fixed inset-x-0 bottom-0 z-20 border-t border-gray-200 bg-white/95 px-4 py-3 '
        + 'shadow-[0_-2px_12px_rgba(0,0,0,0.08)] backdrop-blur'}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-end gap-4">
        {/* Shaped like the rest of the customer flow's buttons: a pill, matching
            the 50px radius that Button/v2 and the cart's own buttons share.
            ONE solid 1px stroke, like the cart dialog's secondary button — not a
            heavy two-tone border that inverts its colours on hover. */}
        <button
          type="button"
          onClick={onContinue}
          className={'min-h-[46px] rounded-gift-pill border border-gift-accent bg-white px-6 text-sm font-bold '
            + 'text-gift-accent transition hover:bg-gift-accent/5 '
            + 'focus:outline-none focus-visible:ring-2 focus-visible:ring-gift-accent'}
        >
          Continue to Cart
        </button>
      </div>
    </div>
  );
}

ContinueToCartBar.propTypes = {
  onContinue: PropTypes.func.isRequired,
};
